import {PromoCode} from './PromoCode';

export const DEVICE = {
  APP: 'APP',
  WEB: 'WEB',
} as const;

export const SERVICE = {
  BOX: 'box',
  LOOK_IN: 'shop',
} as const;

export type Device = (typeof DEVICE)[keyof typeof DEVICE];
export type Service = (typeof SERVICE)[keyof typeof SERVICE];

export type RedeemPromoCodeCommand = {
  promoCode: string;
  device: Device;
  service: Service;
};
export interface PromoCodeRepository {
  redeemPromoCode({promoCode, device, service}: RedeemPromoCodeCommand): Promise<PromoCode>;
}
